import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ButtonModule,
  FitTextModule,
  FormFieldModule,
  DefaultImageModule,
} from '@shared/components/games';
import { CalculatorModule } from '@shared/components/games/calculator/calculator.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { NodAndNokControllerComponent } from './nod-and-nok-controller/nod-and-nok-controller.component';
import { NodAndNokCorrectAnswerPreviewComponent } from './nod-and-nok-preview/nod-and-nok-answer-preview/nod-and-nok-answer-preview.component';
import { NodAndNokExamplePreviewComponent } from './nod-and-nok-preview/nod-and-nok-example-preview/nod-and-nok-example-preview.component';
import { NodAndNokParametersPreviewComponent } from './nod-and-nok-preview/nod-and-nok-parameters-preview/nod-and-nok-parameters-preview.component';
import { NodAndNokUserAnswerPreviewComponent } from './nod-and-nok-preview/nod-and-nok-user-answer-preview/nod-and-nok-user-answer-preview.component';
import { NodAndNokSettingsComponent } from './nod-and-nok-settings/nod-and-nok-settings.component';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { MathGamesSharedModule } from '@games/games-shared/math-games-shared.module';
import { VirtualKeyboardDirective } from '@games/core/input/VirtualKeyboard';
import { CalculatorLayoutComponent } from '@shared/components/games/input-layouts/calculator-layout/calculator-layout.component';

@NgModule({
  declarations: [
    NodAndNokControllerComponent,
    NodAndNokSettingsComponent,
    NodAndNokCorrectAnswerPreviewComponent,
    NodAndNokExamplePreviewComponent,
    NodAndNokParametersPreviewComponent,
    NodAndNokUserAnswerPreviewComponent,
  ],
  exports: [
    NodAndNokControllerComponent,
    NodAndNokSettingsComponent,
    NodAndNokCorrectAnswerPreviewComponent,
    NodAndNokExamplePreviewComponent,
    NodAndNokParametersPreviewComponent,
    NodAndNokUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ButtonModule,
    FitTextModule,
    NgSelectModule,
    DefaultImageModule,
    FormFieldModule,
    CalculatorModule,
    MathGamesSharedModule,
    VirtualKeyboardDirective,
    CalculatorLayoutComponent,
  ],
})
export class NodAndNokModule {}
